export const hardnessTemplate = [
  { header: 'generateReport.dataToResult.report.general.document_version' },
  { header: 'generateReport.dataToResult.report.general.id_ensaio' },
  { header: 'generateReport.dataToResult.report.general.id_hex' },
  { header: 'generateReport.dataToResult.report.general.product' },
  { header: 'generateReport.dataToResult.report.general.product_version' },
  { header: 'generateReport.dataToResult.report.general.date_authorised' },
  { header: 'generateReport.dataToResult.report.general.observacao_geral' },
  { header: 'generateReport.dataToResult.report.general.text_comentario' },

  { header: 'generateReport.dataToResult.report.general.planta_origem' },
  { header: 'generateReport.dataToResult.report.general.data_cadastro' },
  {
    header:
      'generateReport.dataToResult.report.general.data_liberacao_resultado',
  },
  { header: 'generateReport.dataToResult.report.general.amostra_mes' },
  { header: 'generateReport.dataToResult.report.general.desc_cliente' },
  { header: 'generateReport.dataToResult.report.general.descricao_mes' },
  { header: 'generateReport.dataToResult.report.general.firma_insp' },
  { header: 'generateReport.dataToResult.report.general.pedido' },
  { header: 'generateReport.dataToResult.report.general.item' },
  { header: 'generateReport.dataToResult.report.general.corrida' },
  { header: 'generateReport.dataToResult.report.general.ordem_de_processo' },
  { header: 'generateReport.dataToResult.report.general.lote_tt' },
  { header: 'generateReport.dataToResult.report.general.ippn' },
  { header: 'generateReport.dataToResult.report.general.posicao_amostra' },
  { header: 'generateReport.dataToResult.report.general.id_amostra' },
  { header: 'generateReport.dataToResult.report.test.hardness.metodo' },
  { header: 'generateReport.dataToResult.report.test.hardness.quadrante' },
  { header: 'generateReport.dataToResult.report.test.hardness.dext1' },
  { header: 'generateReport.dataToResult.report.test.hardness.dext2' },
  { header: 'generateReport.dataToResult.report.test.hardness.dext3' },
  { header: 'generateReport.dataToResult.report.test.hardness.dext4' },
  { header: 'generateReport.dataToResult.report.test.hardness.dextm' },
  { header: 'generateReport.dataToResult.report.test.hardness.dmei1' },
  { header: 'generateReport.dataToResult.report.test.hardness.dmei2' },
  { header: 'generateReport.dataToResult.report.test.hardness.dmei3' },
  { header: 'generateReport.dataToResult.report.test.hardness.dmei4' },
  { header: 'generateReport.dataToResult.report.test.hardness.dmeim' },
  { header: 'generateReport.dataToResult.report.test.hardness.dint1' },
  { header: 'generateReport.dataToResult.report.test.hardness.dint2' },
  { header: 'generateReport.dataToResult.report.test.hardness.dint3' },
  { header: 'generateReport.dataToResult.report.test.hardness.dint4' },
  { header: 'generateReport.dataToResult.report.test.hardness.dintm' },
  { header: 'generateReport.dataToResult.report.test.hardness.dmedia' },
  { header: 'generateReport.dataToResult.report.test.hardness.dvarmx' },

  { header: 'generateReport.dataToResult.report.test.hardness.ext1_min' },
  { header: 'generateReport.dataToResult.report.test.hardness.ext1_max' },
  { header: 'generateReport.dataToResult.report.test.hardness.ext2_min' },
  { header: 'generateReport.dataToResult.report.test.hardness.ext2_max' },
  { header: 'generateReport.dataToResult.report.test.hardness.ext3_min' },
  { header: 'generateReport.dataToResult.report.test.hardness.ext3_max' },
  { header: 'generateReport.dataToResult.report.test.hardness.ext4_min' },
  { header: 'generateReport.dataToResult.report.test.hardness.ext4_max' },
  { header: 'generateReport.dataToResult.report.test.hardness.extme_min' },
  { header: 'generateReport.dataToResult.report.test.hardness.extme_max' },
  { header: 'generateReport.dataToResult.report.test.hardness.mei1_min' },
  { header: 'generateReport.dataToResult.report.test.hardness.mei1_max' },
  { header: 'generateReport.dataToResult.report.test.hardness.mei2_min' },
  { header: 'generateReport.dataToResult.report.test.hardness.mei2_max' },
  { header: 'generateReport.dataToResult.report.test.hardness.mei3_min' },
  { header: 'generateReport.dataToResult.report.test.hardness.mei3_max' },
  { header: 'generateReport.dataToResult.report.test.hardness.mei4_min' },
  { header: 'generateReport.dataToResult.report.test.hardness.mei4_max' },
  { header: 'generateReport.dataToResult.report.test.hardness.getMeiMedMin' },
  { header: 'generateReport.dataToResult.report.test.hardness.getMeiMedMax' },
  { header: 'generateReport.dataToResult.report.test.hardness.varmx_min' },
  { header: 'generateReport.dataToResult.report.test.hardness.varmx_max' },
  { header: 'generateReport.dataToResult.report.test.hardness.media_min' },
  { header: 'generateReport.dataToResult.report.test.hardness.media_max' },
]
